import React, { useEffect, useMemo, useState } from 'react';

import styles from './PaymentOptionStyles.module.css';
import { DropdownList } from '../common/dropdown-list/DropdownList';
import { PromoText } from '../common/promo-text/PromoText';

const PaymentOptionItem = (props) => {
    const [direction, setDirection] = useState('');
    const [selectedType, setSelectedType] = useState('');
    const [selectedTypeData, setSelectedTypeData] = useState([]);

    useEffect(() => {
        if (props.items.length > 0) {
            setDirection(props.items[0].payment_direction?.title);
            setSelectedType(props.items[0].payment_type?.title);
            setSelectedTypeData(props.items[0].methods);
        }
    }, [props.items]);

    const options = useMemo(
        () =>
            props.items.map((item) => ({
                key: item.payment_type?.title,
                value: item.payment_type?.title,
            })),
        [props.items],
    );

    const handleTypeChange = (item) => {
        setSelectedType(item.value);
        const data = props.items.find((itm) => itm.payment_type.title === item.value);
        setSelectedTypeData(data.methods);
    };

    const methodsList = useMemo(() => {
        return selectedTypeData.map((method) => ({
            id: method.id,
            channel: method.channel,
            settlement_time: method.settlement_time,
            currencies: method.currencies,
            details: method.details,
        }));
    }, [selectedTypeData]);

    return (
        <>
            {selectedType && (
                <div className={styles.paymentOptionItem}>
                    <div className={styles.paymentOptionHeader}>
                        <div className={styles.paymentOptionTitle}>
                            <PromoText variant={'subheader'} color={'white'}>
                                {direction}
                            </PromoText>
                        </div>
                        <div>
                            <DropdownList listItems={options} onSelectChange={handleTypeChange} />
                        </div>
                    </div>
                    <div className={styles.paymentOptionMethods}>
                        {methodsList.length > 0 &&
                            methodsList.map((methodsList) => (
                                <div className={styles.paymentOptionMethod} key={methodsList.id}>
                                    <div className={styles.paymentOptionRow}>
                                        <PromoText color={'white'} isBold>
                                            {methodsList.channel}
                                        </PromoText>
                                        {methodsList.details && <span className={styles.methodListDetails}>{methodsList.details}</span>}
                                    </div>
                                    {methodsList.settlement_time || methodsList.currencies ? (
                                        <>
                                            <span className={styles.methodListSettlement}>{methodsList.settlement_time}</span>
                                            {methodsList.currencies && <span className={styles.methodListCurrencies}>{methodsList.currencies}</span>}
                                        </>
                                    ) : null}
                                </div>
                            ))}
                    </div>
                </div>
            )}
        </>
    );
};

export default PaymentOptionItem;
